import React from 'react';
import Icon from './Icon';
import { brands } from '../data';

export default function Brands() {
  return (
    <section className="section brands" id="brands">
      <div className="container container--wide">
        <header className="section__head">
          <h2 className="section__title">Five Brands. One Vision.</h2>
          <p className="section__sub">
            Purpose-led brands creating meaningful impact across every
            celebration and life journey.
          </p>
        </header>

        <div className="brand-grid">
          {brands.map((b) => (
            <article className="brand-card" key={b.id} style={{ '--c': b.color }}>
              <div className="brand-card__media">
                <img className="brand-card__photo" src={b.photo} alt={b.name} />
                <span className="brand-card__veil" />
                <div className="brand-card__id">
                  {b.logo ? (
                    <img
                      className="brand-card__logo"
                      src={b.logo}
                      alt={b.name}
                    />
                  ) : (
                    <span className="brand-card__word">{b.name}</span>
                  )}
                  <span className="brand-card__tag">{b.tagline}</span>
                </div>
              </div>
              <div className="brand-card__body">
                <p className="brand-card__desc">{b.blurb}</p>
                <a
                  href={b.website || '#contact'}
                  className="brand-card__link"
                  target={b.website ? '_blank' : undefined}
                  rel={b.website ? 'noopener noreferrer' : undefined}
                >
                  Explore {b.name} <Icon name="arrow-right" size={15} />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="brands__cta">
          <a href="#contact" className="btn btn--outline">
            Explore All Brands <Icon name="arrow-right" size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
